import React from 'react';
import { motion } from 'framer-motion';
const galleryItems = [{
  label: 'Portavelas decorativos',
  img: 'https://cdn.magicpatterns.com/uploads/jE4WD2aaUEhcKYx8St13Az/portavelas.jpg'
}, {
  label: 'Atrapasoles',
  img: 'https://cdn.magicpatterns.com/uploads/oPbVxmyNg2n4rNed47w9bK/atrapasoles_mandalas.jpg'
}, {
  label: 'Espejos',
  img: 'https://cdn.magicpatterns.com/uploads/tBbas6pAAFR25F42o41Lto/mandalas_espejo.jpg'
}, {
  label: 'Cuadros efecto vitral',
  img: 'https://cdn.magicpatterns.com/uploads/8ucbNBtJFTWQrh1rnoWx2p/cuadros_efecto_vitral.jpg'
}, {
  label: 'Souvenirs personalizados',
  img: 'https://cdn.magicpatterns.com/uploads/1K6UkSRgGymAkv1aqkkwhD/souvenirs.jpg'
}, {
  label: 'Vajilla elegante',
  img: 'https://cdn.magicpatterns.com/uploads/893A5w4NAkmjiiM1aehzdH/vajilla.jpg'
}];
export function Gallery() {
  const scrollToPurchase = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-deco-cream py-14 sm:py-20 px-4 sm:px-6 lg:px-8" style={{
    backgroundColor: "#FFFCF9",
    backgroundImage: "none"
  }} data-id="element-77" data-mp="rc1jkqnvmwdm">
      <div className="max-w-5xl mx-auto" data-id="element-78" data-mp="112cmqazql1jg">
        <p className="text-center text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-deco-brick mb-4" data-id="element-79" data-mp="113fe0k0z15zw">
          Resultados posibles
        </p>
        <h2 className="text-center font-serif text-2xl sm:text-4xl text-deco-forest font-semibold mb-4" data-id="element-80" data-mp="8dynxt0tq16u">
          Todo lo que puedes crear con{' '}
          <span className="italic text-deco-brick" data-id="element-81" data-mp="ddblp8t8gso7">esta guía</span>
        </h2>
        <p className="text-center text-sm text-deco-forest/60 max-w-xl mx-auto mb-12 leading-relaxed" data-id="element-82" data-mp="hdbyyq4lixto">
          Usa las plantillas imprimibles para crear piezas decorativas sin tener
          que dibujar desde cero.
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5" data-id="element-83" data-mp="1stag7h9xgq5z">
          {galleryItems.map((item, i) => <motion.figure key={item.label} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="group" data-id="element-84" data-mp="1xuq0h74a6snb" data-mpi={i}>
              <div className="rounded-[1.25rem] overflow-hidden aspect-[4/5] bg-deco-beige border border-deco-forest/8" data-id="element-85" data-mp="2p74m19lbbn5">
                <img src={item.img} alt={item.label} className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.04]" data-id="element-86" data-mp="3b61wymsrhdmz" />
              </div>
              <figcaption className="text-center font-serif italic text-sm sm:text-base text-deco-forest/80 mt-3" data-id="element-87" data-mp="3kvd25ycj1y5l">
                {item.label}
              </figcaption>
            </motion.figure>)}
        </div>

        <div className="text-center mt-12" data-id="element-88" data-mp="2sdr1vf4cmjzf">
          <button onClick={scrollToPurchase} className="px-10 py-4 rounded-full bg-deco-brick text-white font-semibold text-sm tracking-wide shadow-lg hover:bg-deco-brick-dark transition-colors duration-200" data-id="element-89" data-mp="2scfwxbz6366q">
            QUIERO APRENDER A CREARLAS
          </button>
        </div>
      </div>
    </section>;
}